import { Alert, Card, Switch, Typography, message } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import {
  GetProcessStartSettings,
  UpdateProcessStartSettings,
} from '../helper/apiHelper';
import { QUERY_KEYS } from '../Constants/queryKeys';
import type { ProcessStartSettings } from '../Types/interfaces';

const SWITCHES: Array<{ key: keyof ProcessStartSettings; labelKey: string }> = [
  {
    key: 'companyRegistrationEnabled',
    labelKey: 'processStartSettings.companyRegistration',
  },
  {
    key: 'internshipApplicationEnabled',
    labelKey: 'processStartSettings.internshipApplication',
  },
  {
    key: 'internshipOfferCreationEnabled',
    labelKey: 'processStartSettings.internshipOfferCreation',
  },
];

export const ProcessStartSettingsComponent = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [messageApi, contextHolder] = message.useMessage();

  const { data: settings, isLoading } = useQuery({
    queryKey: QUERY_KEYS.PROCESS_START_SETTINGS,
    queryFn: GetProcessStartSettings,
  });

  const updateMutation = useMutation({
    mutationFn: UpdateProcessStartSettings,
    onSuccess: (updated) => {
      queryClient.setQueryData(QUERY_KEYS.PROCESS_START_SETTINGS, updated);
      messageApi.success(t('processStartSettings.saved'));
    },
    onError: () => {
      messageApi.error(t('processStartSettings.saveError'));
    },
  });

  return (
    <>
      {contextHolder}
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message={t('processStartSettings.info')}
      />
      <Card loading={isLoading}>
        {SWITCHES.map(({ key, labelKey }) => (
          <div
            key={key}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px 0',
            }}
          >
            <Typography.Text strong>{t(labelKey)}</Typography.Text>
            <Switch
              checked={settings?.[key] ?? true}
              loading={updateMutation.isPending}
              checkedChildren={t('processStartSettings.enabled')}
              unCheckedChildren={t('processStartSettings.blocked')}
              onChange={(checked) => updateMutation.mutate({ [key]: checked })}
            />
          </div>
        ))}
      </Card>
    </>
  );
};
